/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function ApiClientInputFromJSON(json) {
    return ApiClientInputFromJSONTyped(json, false);
}
export function ApiClientInputFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'abn': !exists(json, 'abn') ? undefined : json['abn'],
        'billingAddress': !exists(json, 'billingAddress') ? undefined : json['billingAddress'],
        'businessName': !exists(json, 'businessName') ? undefined : json['businessName'],
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'hostName': !exists(json, 'hostName') ? undefined : json['hostName'],
        'invoiceAddressTo': !exists(json, 'invoiceAddressTo') ? undefined : json['invoiceAddressTo'],
        'ip': !exists(json, 'ip') ? undefined : json['ip'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'timezone': !exists(json, 'timezone') ? undefined : json['timezone'],
        'website': !exists(json, 'website') ? undefined : json['website'],
    };
}
export function ApiClientInputToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'abn': value.abn,
        'billingAddress': value.billingAddress,
        'businessName': value.businessName,
        'firstName': value.firstName,
        'hostName': value.hostName,
        'invoiceAddressTo': value.invoiceAddressTo,
        'ip': value.ip,
        'lastName': value.lastName,
        'timezone': value.timezone,
        'website': value.website,
    };
}
